import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild
} from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
@Component({
  selector: 'staff-info-report',
  templateUrl: './staff-info-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule
  ]
})
export class StaffInfoReportComponent  {
  @Input() columnData=new BehaviorSubject(null);
  @Input() additionData=new BehaviorSubject(null);
  @ViewChild('op') op: Popover;
  @ViewChild('op2') op2: Popover;


  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false
  }

}